import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormControl, FormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-upload-defect-report-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./upload-defect-report-modal.component.html",
  styleUrl: "./upload-defect-report-modal.component.scss",
})
export class UploadDefectReportModalComponent {
  @Input()
  configs: any = {};

  activeModal = inject(NgbActiveModal);
  defectFileControl = new FormControl("", [Validators.required]);
  isActive: boolean = false;
  isDragOver: boolean = false;
  selectedFile: File | null = null;
  showGithubUrl: boolean = false;


  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.validateAndProcessFile(files[0]);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.validateAndProcessFile(input.files[0]);
      input.value = '';
    }
  }

  private validateAndProcessFile(file: File): void {
    this.defectFileControl.markAsTouched();

    if (!this.isValidFileType(file)) {
      this.selectedFile = null;
      this.defectFileControl.setValue('');
      this.defectFileControl.setErrors({ invalidFileType: true });
      return;
    }

    if (file.name.includes(' ')) {
      this.selectedFile = null;
      this.defectFileControl.setValue('');
      this.defectFileControl.setErrors({ fileNameHasSpace: true });
      return;
    }

    this.processFile(file);
  }

  private isValidFileType(file: File): boolean {
    return file.name.toLowerCase().endsWith(".csv");
  }

  private processFile(file: File): void {
    this.selectedFile = file;
    this.defectFileControl.setValue(file.name);
    this.defectFileControl.setErrors(null);
    this.defectFileControl.markAsTouched();
  }

  handleFilesSelected(event: any): string {
    if (event?.files && event.files.length > 0) {
      const fileNames = event.files.map((file: File) => file.name).join(", ");
      this.defectFileControl.setValue(fileNames);
      return fileNames;
    }
    return "";
  }

  save(){
     this.activeModal.close({
      value: {
        githubUrl: this.showGithubUrl ? this.configs?.data?.githubLink : null,
        file: this.selectedFile,
      },
    });
  }
}
